import Gauge from '@/components/Gauge';
import { toFactor } from '@/utilities/formatting';

export interface Props {
  companyPEG: number;
  companyName: string;
}

const keys = ['company'];

const PEGRatioGauge = ({ companyPEG, companyName }: Props) => {
  const entities = {
    [keys[0]]: companyPEG,
  };
  const entityTitles = {
    [keys[0]]: companyName,
  };
  return (
    <Gauge
      title="PEG Ratio"
      keys={keys}
      entityTitles={entityTitles}
      entities={entities}
      formatter={(value: number | null) =>
        value !== null ? toFactor(value, 1) : 'n/a'
      }
      numTicks={5}
      from={0}
      to={4}
      flip={true}
    />
  );
};

export default PEGRatioGauge;
